import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Col, FormGroup } from 'reactstrap';
import LessonItem from './GridItem';
import Pagination from '../../components/_Pagination';
import { loadLessons } from '../../actions/lessons';
import { getUrlParams, setUrlParams } from '../../utils/helper';
import { isLocal, domain } from '../../config';
import Loading from './Loading';

const path = isLocal ? '//localhost:3002/#' : `${domain}/company/#`;

const limit = 12;

const mapStateToProps = ({ user: { permissions, options }, lessons: { list, total } }) => ({
  permissions: permissions || [],
  allow_chat: options.allow_chat,
  hide_links_on_learning: options.hide_links_on_learning,
  all_in_one_tab: options.all_in_one_tab,
  new_question_new_tab: options.new_question_new_tab,
  list,
  total,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  loadItems: loadLessons,
}, dispatch);

const Lessons = ({ match, history, permissions, allow_chat, hide_links_on_learning, all_in_one_tab, new_question_new_tab, list, total, loadItems }) => {

  const getPageFromUrl = () => {
    const urlParams = getUrlParams(history.location.search);
    return urlParams.page ? +urlParams.page : 1;
  };

  const [page, setPage] = useState(getPageFromUrl());
  const reload = () => setPage(getPageFromUrl());

  useEffect(() => {
    window.addEventListener('hashchange', reload, false);

    return () => window.removeEventListener('hashchange', reload, false);
  }, []);

  useEffect(() => {
    loadItems(+match.params.id, {
      limit,
      ...(page === 1 ? {} : { offset: (page - 1) * limit })
    });
  }, [page]);

  if (!list || !list.length) {
    return <Loading />;
  }

  if (!permissions.includes('TRAINING_LESSONS_LIST')) {
    return null;
  }

  return (
    <div>
      {!hide_links_on_learning &&
        <div className="category_block">
          <ul>
            {allow_chat && (
              <li className="category">
                <Link to="/trainings/chats" target={all_in_one_tab ? "_self" : "_blank"}>
                  <i className="icon_c icon_c_bg icon_chats" />
                  <FormattedMessage id="routes_chats" />
                </Link>
              </li>
            )}
            <li className="category">
              <a href={`${path}/reports/users`} target={all_in_one_tab ? "_self" : "_blank"} rel="noreferrer">
                <i className="icon_c icon_c_bg icon_reports" />
                <FormattedMessage id="routes_reports" />
              </a>
            </li>
            <li className="category">
              <Link to={`/trainings/mytrainings/${match.params.id}/results`} target={all_in_one_tab ? "_self" : "_blank"}>
                <i className="fa fa-signal" />
                <FormattedMessage id="lessons_myStats" />
              </Link>
            </li>
            <li className="category">
              <Link to={`/trainings/mytrainings/${match.params.id}/notes`} target={all_in_one_tab ? "_self" : "_blank"}>
                <i className="icon_c icon_c_bg icon_notes" />
                <FormattedMessage id="routes_notes" />
              </Link>
            </li>
            <li className="category">
              <Link to={`/trainings/mytrainings/${match.params.id}/pictures`} target={all_in_one_tab ? "_self" : "_blank"}>
                <i className="icon_c icon_c_bg icon_images" />
                <FormattedMessage id="routes_pictures" />
              </Link>
            </li>
          </ul>
        </div>
      }
      <div className="tiles">{list.map(item =>
        <LessonItem key={item.id} item={{ ...item, training_id: +match.params.id }} all_in_one_tab={all_in_one_tab} new_question_new_tab={new_question_new_tab} />)}
      </div>
      <Col>
        <FormGroup>
          <Pagination
            activePage={page}
            itemsPerPage={limit}
            totalItems={total}
            onChange={num => setUrlParams({ ...(num === 1 ? {} : { page: num }) })}
          />
        </FormGroup>
      </Col>
      <div className="clear10" />
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Lessons);



// WEBPACK FOOTER //
// ./src/views/_Lessons/index.js